import React from 'react';

import { ComplianceColorDot } from 'components/common/Tables/Cells/ComplianceColorDot/ComplianceColorDot';
import { ValidationNameCell } from 'components/common/Tables/Cells/ValidationNameCell/ValidationNameCell';

import { CustomizedTooltip } from 'components/common';
import classes from 'components/widgets/LogicQualityCategoriesTable/LogicQualityCategoriesTable.module.scss';
import { LogicQualityCheckCardWidget } from 'components/widgets/LogicQualityCheckCardWidget/LogicQualityCheckCardWidget';

export const categoryColumns = (
    category,
    inScoreNumber,
    projectId,
    contractId,
    versionName,
    fileMetaDataId,
    versionHashCode,
) => {
    return [
        {
            header: 'Validation Type',
            accessorKey: 'validationName',
            id: 'validationName',
            width: 410,
            cell: ({ getValue, row }) => {
                const value = getValue();
                const safeValue = value.replace('/', '_');
                const isDCMA: boolean = row.original.dcma;
                return (
                    <ValidationNameCell
                        value={value}
                        safeValue={safeValue}
                        isDCMA={isDCMA}
                        category={category}
                        versionHashCode={versionHashCode}
                    />
                );
            },
        },
        {
            header: 'Compliance',
            id: 'status',
            accessorFn: (rowOriginal) => (rowOriginal.mandatory ? rowOriginal.status : undefined),
            cell: ({ getValue }) => <ComplianceColorDot value={getValue()} />,
            width: 180,
        },
        {
            header: 'Result',
            accessorKey: 'result',
            id: 'result',
            width: 200,
        },

        {
            header: 'Target Threshold',
            accessorKey: 'threshold',
            id: 'threshold',
            width: 200,
        },
        {
            header: 'Score Deduction',
            accessorKey: 'negativeScoreImpact',
            id: 'negativeScoreImpact',
            cell: ({ getValue }) => {
                const value = getValue();
                return (
                    <CustomizedTooltip
                        triggerElement={
                            <div className={classes.scoreDeduction}>
                                {value === 0 || value === null ? '' : value * -1}
                            </div>
                        }
                        tooltipContent={`100 / ${inScoreNumber} active checks`}
                    />
                );
            },
            width: 200,
        },
        {
            header: 'Status',
            id: 'cardWidget',
            accessorKey: 'associatedCard.status.label',
            cell: ({ row }) => {
                return (
                    <LogicQualityCheckCardWidget
                        projectId={projectId}
                        contractId={contractId}
                        versionName={versionName}
                        cardId={row.original.associatedCard?.cardId}
                        status={row.original.associatedCard?.status}
                        assignee={row.original.associatedCard?.assignee}
                        title={row.original.validationName}
                        metaDataId={fileMetaDataId}
                        checkId={row.original.validationId}
                    />
                );
            },
            width: 215,
        },
    ];
};
